import React from 'react';
import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Paper,
  Typography
} from '@mui/material';

interface Question {
  id: number;
  text: string;
  options: string[];
  correctAnswer: number;
  userAnswer?: number;
  isMarkedForReview?: boolean;
}

interface AnswerSectionProps {
  question: Question;
  onAnswerSelect: (answerIndex: number) => void;
}

const AnswerSection: React.FC<AnswerSectionProps> = ({ question, onAnswerSelect }) => {
  const handleAnswerChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // Ensure we're getting the correct index value (0-3) from the radio buttons
    const answerIndex = parseInt(event.target.value, 10);
    
    // Log the actual value we're getting
    
    // Only pass the answer index, as expected by the parent component
    onAnswerSelect(answerIndex);
  };

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Select your answer:
      </Typography>
      
      <FormControl component="fieldset">
        <RadioGroup
          value={question.userAnswer?.toString() || ''}
          onChange={handleAnswerChange}
        >
          {question.options.map((option, index) => (
            <FormControlLabel
              key={index}
              value={index.toString()}
              control={<Radio />}
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography
                    sx={{
                      fontWeight: 'bold',
                      minWidth: '24px',
                      textAlign: 'center'
                    }}
                  >
                    {String.fromCharCode(65 + index)}.
                  </Typography>
                  <Typography dangerouslySetInnerHTML={{ __html: option }} />
                </Box>
              }
              sx={{
                mb: 1,
                '& .MuiFormControlLabel-label': {
                  width: '100%'
                }
              }}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </Paper>
  );
};

export default AnswerSection;